import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon VideoPlayIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const VideoPlayIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 34 34">
      <path
        d="M17 33.6668C26.2047 33.6668 33.6666 26.2049 33.6666 17.0002C33.6666 7.79542 26.2047 0.333496 17 0.333496C7.79523 0.333496 0.333313 7.79542 0.333313 17.0002C0.333313 26.2049 7.79523 33.6668 17 33.6668Z"
        fill="#EB3C96"
      />
      <path
        d="M24.44 15.5503C24.6965 15.6956 24.9098 15.9064 25.0583 16.1612C25.2067 16.4159 25.2849 16.7055 25.2849 17.0003C25.2849 17.2951 25.2067 17.5846 25.0583 17.8394C24.9098 18.0941 24.6965 18.3049 24.44 18.4503L14.5 24.0836C14.2461 24.2302 13.9581 24.3072 13.665 24.3069C13.3719 24.3066 13.084 24.229 12.8305 24.082C12.5769 23.9349 12.3666 23.7236 12.2208 23.4693C12.075 23.215 11.9988 22.9267 12 22.6336V11.3686C11.9988 11.0755 12.075 10.7872 12.2208 10.533C12.3666 10.2787 12.5769 10.0673 12.8305 9.92026C13.084 9.77319 13.3719 9.6956 13.665 9.69531C13.9581 9.69502 14.2461 9.77205 14.5 9.91861L24.44 15.5503Z"
        fill="#FFDCB9"
      />
    </Icon>
  )
}
export default VideoPlayIcon
